import Vue from "vue"
import VueResource from "vue-resource"
import VConsole from 'vconsole'
import {getQueryString} from '../common/js/util'

Vue.use(VueResource)

export default {
    /**
   * 完善信息页点击选项
  //  */
     getLoginStatus: function({ commit, dispatch, state }, params) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get(`${state.origin}/api/login/getLoginStatus`)
                .then(res => {
                    if (res.body.status.error === 0) {
                        GLOBAL.setInfo('LoginStatus',true)
                        var userInfo = {}
                        userInfo = {
                            avatarUrl: res.body.result.avatar
                                ? res.body.result.avatar.imgUrl
                                : '',
                            displayName: res.body.result.displayname,
                            id: res.body.result.id
                        }
                        commit('OWER_VIEW_INIT', userInfo)
                        if(res.body.result.id == '206509'){
                            var vConsole = new VConsole()
                        }
                        let source =
                            getQueryString("source") || GLOBAL.getCookie("LoginSource")
                        if (source) {
                            Vue.http
                                .post(`${state.origin}/api/user/setSource?source=${source}`)
                                .then(() => {
                                })
                                .catch(err => { })
                        }
                        resolve(res.data.result)
                    } else {
                        GLOBAL.setInfo('LoginStatus',false)
                        reject(res.data.status.message)
                    }
                }).catch((err) => {
                    reject(err)
                })
        })
    },
    makeOrder: function({ commit, dispatch, state }, params){
        return new Promise((resolve, reject) => {
            console.log(GLOBAL)
            Vue.http
                .post(`${state.origin}/api/transaction/makeOrder`, {
                    coin: 0, //使用萌豆数，最少10或者0，必须能被10整除
                    couponId: null, //优惠券ID
                    openId: params.openId, //微信环境下需要提供openId
                    originPaidItem: null, //相关商品ID。补差价时提供询问单ID；追问时提供queryReply的ID，其他时候不需要
                    payMethod: GLOBAL.inWeixin ? 'Weixin' : 'Alipay', //支付方式，支付宝/微信
                    payPlatform: GLOBAL.inWeixin ? 'MobileWeb' : 'Desktop', //支付平台，桌面/移动
                    queryPriceId: params.queryPriceId, //购买的商品ID
                    returnUrl: location.href, //支付宝下可用，若提供则支付成功跳转该页面，不提供跳转到首页
                    useMemberClassFree: params.useMemberClassFree, //	boolean是否使用会员免费特权
                    promotionString: params.promotionString?params.promotionString:''
                })
                .then(res => {
                    if (res.body.status.error === 0) {
                        resolve(res.data.result)
                    }

                }).catch(err=>{
                    reject(err)
                })
        })
    },
    canViewVet2: function({ commit, dispatch, state }, params) {
        state.canViewVet2 = true
        let userProfile = state.userProfile
        if (userProfile != null) {
            if (userProfile.permissions instanceof Array) {
                userProfile.permissions.forEach(permission => {
                    if (permission == "viewVet2") {
                        state.canViewVet2 = true
                    }
                })
            }
        }
    },
    // 获取用户详细信息及会员信息
    getProfile: function({ commit, dispatch, state }, params) {
        return new Promise(async(resolve, reject) => {
            // ${state.ownerView.id}
            console.log(this)
            if (!state.ownerView) {
                await dispatch("getLoginStatus")
            }
            await Vue.http
                .get(`${state.origin}/api/login/getLoginStatus`)
                .then(res => {
                    if (res.data.status.error == 0) {
                        commit('USER_PROFILE', res.data.result)
                        let userProfile = res.data.result
                        if (userProfile != null) {
                            if (userProfile.extra != null && userProfile.extra.vip != null) {
                                state.userIdentity = userProfile.extra.vip.vipClass
                            } else {
                                state.userIdentity = 'no-vip'
                            }
                        }
                        resolve(res.data.result)
                    }
                })
        })
    },
    // 获取vip用户信息
    findVIPUserInfo: function({ commit, dispatch, state }, params) {
        // debugger
        console.log(state.ownerView)
        Vue.http
            .get(`${state.origin}/vip/getVIPInfo?userId=${state.ownerView.id}`)
            .then(rep => {
                if (params && params.callback) {
                    params.callback(rep)
                }
                console.log(rep)
                if (rep.data.status.error == 0) {
                    commit('VIP_USER_INFO', rep.data.result)
                    if (rep.data.result) {
                        if (
                            rep.data.result.weChatId &&
                            rep.data.result.location &&
                            rep.data.result.phone
                        ) {
                            state.completeInformation = true
                            return true
                        } else {
                            state.completeInformation = false
                            return false
                        }
                    } else {
                        state.completeInformation = false
                        return false
                    }
                }
            }
            )
    },
    // 保存vip用户信息
    saveVIPUserInfo: function({ commit, dispatch, state }, data) {
        return new Promise((resolve, reject) => {
            Vue.http
                .put(
                    `${state.origin}/vip/saveVIPInfo?userId=${data.userId}`,
                    data.VIPInfo
                )
                .then(rep => {
                    // data.callback(rep.data)
                    if (rep.data.status.error == 0) {
                        // router.push({path: '/vipInfo'})
                        state.completeInformation = true
                        resolve(rep.data.result)
                    } else {
                        reject(rep.data.status.message)
                    }
                })
        })
    },
    // 获得某天的兽医接受的预约时间
    getReservationTime: function({ state }, params) {
        Vue.http
            .get(
                `${state.origin}/appointment/getReservationTime?date=${params.dateStr}&questionType=${params.questionType}`
            ).then(
                (rep) => {
                    // console.log(rep)
                    if (params.callback) {
                        params.callback(rep)
                    }
                }
            )
    },
    // 更改兽医
    changeVetReservation: function({ state }, date) {
        Vue.http
            .put(
                `${state.origin}/appointment/changeVet?userId=${date.userId}`,
                date.map
            ).then((rep) => {
                date.callback(rep.body.result)
            })
    },
    // 兽医用
    // 获取预约列表
    getAllReservation: function({ state }, { date, callback }) {
        var date = date || "2018-3-3"
        Vue.http
            .get(`${state.origin}/appointment/getAllReservation?date=${date}`).then(
                (rep) => {
                    console.log(rep)
                    if (callback) callback(rep.body.result)
                })
    },
    // 添加预约时间
    addReservation: function({ commit, dispatch, state }, { reservationMap, callback }) {
        Vue.http
            .post(`${state.origin}/appointment/addReservation`, reservationMap)
            .then(rep => {
                callback()
                console.log(rep)
            })
    },
    // 删除某条预约记录
    deleteReservation: function({ state }, { reservationId, callback }) {
        Vue.http
            .get(
                `${state.origin}/appointment/deleteReservation?reservationId=${reservationId}&userId=${state.ownerView.id}`
            ).then(
                (rep) => {
                    console.log(rep)
                    if (callback) callback()
                })
    },
    // 添加预约单记录
    addReply: function({ state }, { userId, content, reservationId, callback }) {
        // var userId = 1,content="您这是没病找病哦豁",reservationId=1
        Vue.http
            .get(
                `${state.origin}/appointment/addReply?userId=${userId}&content=${content}&reservationId=${reservationId}`
            ).then(
                (rep) => {
                    console.log(rep)
                    if (callback) callback()
                })
    },
    // 版本号
    version: function({ state }, { callback }) {
        Vue.http.get(`${state.origin}/appointment/version`).then(rep => {
            callback(rep.body.result, state)
        })
    },
    // 用户失约
    breakPromise: function({ state }, data) {
        Vue.http
            .get(
                `${state.origin}/appointment/breakPromise?userId=${data.userId}&reservationId=${data.reservationId}`
            ).then(
                (rep) => {
                    data.callback(rep.body.result, state)
                })
    },
    // 权限
    getVetByRole: function({ state }, data) {
        Vue.http
            .get(`${state.origin}/appointment/getVetByRole?role=${data.role}`).then(
                (rep) => {
                    data.callback(rep.body.result, state)
                })
    }
}



// WEBPACK FOOTER //
// ./src/store/action.js